<template>
  <DashboardPage>
    <SpinningLoader :pending="pending">
      <PageBreadcrumb
        :crumbs="[{
          label: $t('auction.auctions'),
          link: '/aste'
        }, {
          label: auction.name
        }]"
      >
        <a
          v-if="refreshAuctionEnabled && auction && auction.auctionStatus != 'CLOSED' && auction.auctionStatus != 'PUBLISHED'"
          href="#"
          class="btn btn-cta !text-xs"
          @click.prevent="refreshAuction"
        >{{ $t('common.refresh') }}</a>

        <a
          v-if="!refreshAuctionEnabled && auction && auction.auctionStatus != 'CLOSED' && auction.auctionStatus != 'PUBLISHED'"
          href="#"
          class="btn btn-cta !text-xs cursor-not-allowed opacity-50"
        >{{ $t('common.refresh') }}</a>
      </PageBreadcrumb>

      <AuctionFullItem
        :auction="auction"
        :outbid-lot-uuid="outbidLotUuid"
        @update-auction="updateAuction"
      />
    </SpinningLoader>
  </DashboardPage>
</template>

<script setup>
import { onUnmounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

import AuctionFullItem from '@/components/AuctionFullItem.vue';
import DashboardPage from '@/components/DashboardPage.vue';
import PageBreadcrumb from '@/components/PageBreadcrumb.vue';
import SpinningLoader from '@/components/SpinningLoader.vue';
import useAxios from '@/composables/axios';
import sse from '@/services/sse';

const axios = useAxios()
const route = useRoute()
const { t } = useI18n()

import { useNotificationsStore } from '@/stores/notifications';
const { pushInfo } = useNotificationsStore();

const pending = ref(true)
const auction = ref();
const outbidLotUuid = ref(null);

axios.get('/auction/' + route.params.id).then((resp) => {
  auction.value = resp.data;

  pending.value = false;
}).catch(() => {

});

const updateAuction = function (updatedAuction) {
  auction.value = updatedAuction;
}

const refreshAuctionEnabled = ref(true);

const refreshAuction = function () {
  pending.value = true;
  refreshAuctionEnabled.value = false;
  axios.get('/auction/' + route.params.id).then(async (resp) => {
    auction.value = resp.data;
    pending.value = false;
    setTimeout(() => refreshAuctionEnabled.value = true, 15000);
  }).catch(() => {
    pending.value = false;
  });
}

// the sse stream is shared across all auctions the user can access:
// only handle events belonging to the auction shown on this page
const isCurrentAuction = function (auctionUuid) {
  return auction.value && auctionUuid == auction.value.uuid;
}

const onAuctionUpdated = function (data) {
  //console.log('onAuctionUpdated')
  if (!isCurrentAuction(data.uuid)) {
    return;
  }
  auction.value = data;
}

const onLotOutbid = function (data) {
  //console.log('onLotOutbid')
  if (!isCurrentAuction(data.auctionUuid)) {
    return;
  }
  outbidLotUuid.value = data.lotUuid;
  pushInfo(t('notifications.lot_outbid'));
  setTimeout(() => outbidLotUuid.value = null, 30000);
}

const onAuctionClosed = function (data) {
  //console.log('onAuctionClosed')
  if (!isCurrentAuction(data.uuid)) {
    return;
  }
  auction.value = data;
  pushInfo(t('notifications.auction_closed'));
}

const onAuctionRedistributing1 = function (data) {
  //console.log('onAuctionRedistributing1')
  if (!isCurrentAuction(data.uuid)) {
    return;
  }
  auction.value = data;
  pushInfo(t('notifications.auction_redistributing_1'));
}

const onAuctionRedistributing2 = function (data) {
  //console.log('onAuctionRedistributing2')
  if (!isCurrentAuction(data.uuid)) {
    return;
  }
  auction.value = data;
  pushInfo(t('notifications.auction_redistributing_2'));
}

sse.addListener('AUCTION_UPDATED', onAuctionUpdated);
sse.addListener('LOT_OUTBID', onLotOutbid);
sse.addListener('AUCTION_CLOSED', onAuctionClosed);
sse.addListener('AUCTION_REDISTRIBUTING_1', onAuctionRedistributing1);
sse.addListener('AUCTION_REDISTRIBUTING_2', onAuctionRedistributing2);

onUnmounted(() => {
  //console.log('stacco tutto');
  sse.removeListener('AUCTION_UPDATED');
  sse.removeListener('LOT_OUTBID');
  sse.removeListener('AUCTION_CLOSED');
  sse.removeListener('AUCTION_REDISTRIBUTING_1');
  sse.removeListener('AUCTION_REDISTRIBUTING_2');
});

</script>